module.exports = __webpack_public_path__ + "static/media/mono_widget_instruction.d552cc74.gif";